type OverlayProps = {
	handleClick?: () => void;
};

const Overlay = ({ handleClick }: OverlayProps) => {
	return (
		<div
			onClick={() => handleClick && handleClick()}
			className={`vtex-minicart-2-x-overlay vtex-minicart-2-x-overlay--visible bg-base--inverted z-999 absolute top-0 bottom-0 left-0 right-0`}
			style={{
				opacity: '0.5',
				pointerEvents: 'auto',
				transition: 'opacity 300ms ease 0s',
				position: 'absolute',
				height: '100vh',
				width: '100vw',
			}}
		></div>
	);
};

export default Overlay;
